import { createAction, props } from "@ngrx/store";
import { Sexo } from "./entity-sexo.model";

export const entitySexosLoadRequest = createAction(
  '[ENTITYSEXO] Load Request'
);

export const entitySexosLoadFailure = createAction(
  '[ENTITYSEXO] Load Failure',
  props<{ error: Error }>()
);

export const entitySexosLoadSuccess = createAction(
  '[ENTITYSEXO] Load Success',
  props<{ items: Sexo[] }>()
);
